<template>
  <section class="privilege-group">
    <viewTitle title="权限管理 / 权限组配置" :showReturn="false"></viewTitle>
    <!-- 按钮组 -->
    <section class="controler" style="margin: 10px 0;">
      <div style="display: flex;">
        <el-button type="primary" size="small" @click="createGroup">
          新增权限组
        </el-button>
        <div class="lc">
          <el-input
            placeholder="请输入要搜索的角色名称"
            v-model="params.keyword"
            clearable
            @change="changeKeyword"
            suffix-icon="el-icon-search"
            style="width: 210px;"
          >
          </el-input>
        </div>
      </div>
    </section>
    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        :data="tableData"
        show-overflow-tooltip
        cell-class-name="table-cell"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        :border="true"
      >
        <el-table-column label="角色名称" width="180">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="管理员" width="400">
          <template slot-scope="scope">
            {{ scope.row.admin_fix || "--" }}
          </template>
        </el-table-column> -->
        <el-table-column label="描述">
          <template slot-scope="scope">
            <template v-if="scope.row.description && scope.row.description.length > 0">
              <span>{{ scope.row.description }}</span>
            </template>
            <template v-else>
              <span>--</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div class="action-links">
              <el-button type="text" @click="edit(scope.row)">修改</el-button>
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="params.page"
          :pageSize="params.page_size"
          :count="params.count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>
    <el-dialog
      title="复制角色"
      width="520px"
      :visible.sync="copyDialog.visible"
      @close="resetCopyDialog"
    >
      <el-form
        ref="copyForm"
        :model="copyDialog.form"
        :rules="copyDialog.rules"
        label-width="100px"
      >
        <el-form-item label="角色名称" prop="name">
          <el-input
            v-model="copyDialog.form.name"
            placeholder="请输入新的角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            v-model="copyDialog.form.description"
            placeholder="请输入角色描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="copyDialog.visible = false">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          :loading="copyDialog.submitting"
          @click="submitCopyRole"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import confirm from "@/components/elementPlus/packages/confirm";
export default {
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        page_size: 20,
        count: 0
      },
      tableData: [],
      maxSize: 0,
      loading: false,
      copyDialog: {
        visible: false,
        loading: false,
        submitting: false,
        sourceRole: null,
        form: {
          name: "",
          description: ""
        },
        rules: {
          name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
          description: []
        }
      }
    };
  },
  components: {
    pagi,
    viewTitle
  },
  mixins: [mixinTableLyout],
  computed: {},

  created() {
    this.initWatcher();
    this.fetchList();
  },

  activated() {
    this.fetchList();
  },

  mounted() {},

  methods: {
    // 获取权限组列表数据，并同步更新分页信息。
    fetchList() {
      if (!this.loading) {
        this.loading = true;
        this.$common
          .http({
            url: "/api/role/search_by_page",
            data: this.params
          })
          .then(res => {
            this.loading = false;
            let data = res.data.data;
            let { total, total_page, items } = data;
            console.log(total, total_page, items);
            this.params.count = total;
            // if (list_info.now_page > total_page) {
            //   this.params.page--;
            //   this.fetchList();
            //   return;
            // }
            this.convertData(items);
            this.tableData = items;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 搜索关键字变化后回到第一页重新加载列表。
    changeKeyword() {
      this.params.page = 1;
      this.fetchList();
    },
    // 跳转到新增权限组页面。
    createGroup() {
      this.$router.push("/rhqy/pri/app/index/edit");
    },
    // 跳转到权限组编辑页面。
    edit({ id, code }) {
      this.$router.push(`/rhqy/pri/app/index/edit/${code||'custom'}/${id}`);
    },
    // 删除权限组，并在成功后刷新当前列表。
    del({ id }) {
      confirm({
        confirmAc: () => {
          this.$common
            .http({
              mt: "post",
              url: "/api/role/delete",
              data: {
                id
              }
            })
            .then(() => {
              this.$common.pcToastSuccess("删除成功");
              this.fetchList();
            });
        },
        confirmAcClass: "btnConfirmDanger",
        cancelAcClass: "btnCancel"
      });
    },
    // 打开复制弹窗，并预加载源角色的完整配置用于直建新角色。
    openCopyDialog(row) {
      this.copyDialog.loading = true;
      this.$common
        .http({
          mt: "post",
          url: "/api/role/detail",
          data: {
            id: row.id
          }
        })
        .then(res => {
          const role = res.data.data || {};
          this.copyDialog.sourceRole = role;
          // 关键步骤：默认生成一个可直接保存的新角色名称，并沿用原描述。
          this.copyDialog.form = {
            name: `${row.name || ""}-复制`,
            description: role.description || ""
          };
          this.copyDialog.visible = true;
          this.$nextTick(() => {
            this.$refs.copyForm && this.$refs.copyForm.clearValidate();
          });
        })
        .finally(() => {
          this.copyDialog.loading = false;
        });
    },
    // 将源角色详情转换为复制创建所需的接口参数。
    buildCopyRolePayload() {
      const sourceRole = this.copyDialog.sourceRole || {};
      return {
        name: this.copyDialog.form.name,
        description: this.copyDialog.form.description,
        code: sourceRole.code || "",
        is_fix: sourceRole.is_fix || 0,
        // 关键步骤：复制角色时保留账号前缀，确保外部用户账号生成规则一致。
        acct_prefix: sourceRole.acct_prefix || "",
        data_auth_type: sourceRole.data_auth_type || "",
        // 关键步骤：只复制角色本身配置，不复制任何绑定关系。
        permissions: (sourceRole.permission || []).map(item => item.key),
        department_ids: [],
        write_department_ids: [],
        bind_user_ids: [],
        bind_dept_ids: [],
        bind_tag_ids: []
      };
    },
    // 提交复制角色请求，成功后关闭弹窗并刷新列表。
    submitCopyRole() {
      this.$refs.copyForm.validate(valid => {
        if (!valid || this.copyDialog.submitting) {
          return;
        }

        this.copyDialog.submitting = true;
        this.$common
          .http({
            mt: "post",
            url: "/api/role/create_and_bind",
            data: this.buildCopyRolePayload()
          })
          .then(() => {
            this.$common.pcToastSuccess("复制成功");
            this.copyDialog.visible = false;
            this.fetchList();
          })
          .finally(() => {
            this.copyDialog.submitting = false;
          });
      });
    },
    // 重置复制弹窗状态，避免下次打开残留上一次的数据。
    resetCopyDialog() {
      this.copyDialog.sourceRole = null;
      this.copyDialog.form = {
        name: "",
        description: ""
      };
      this.copyDialog.loading = false;
      this.copyDialog.submitting = false;
      this.$nextTick(() => {
        this.$refs.copyForm && this.$refs.copyForm.clearValidate();
      });
    },
    // 切换分页后重新加载对应页的数据。
    pageChange(page) {
      this.params.page = page;
      this.fetchList();
    },
    // 保留搜索监听扩展位，当前列表使用 change 事件触发查询。
    initWatcher() {
      // const keys = ["params.keyword"];
      // keys.forEach(item => {
      //   this.$watch(
      //     item,
      //     qySebounce(() => {
      //       this.params.page = 1;
      //       this.fetchList();
      //     }, 200)
      //   );
      // });
    },
    // 管理员展示列已下线，列表数据不再依赖角色绑定人员回包。
    convertData(data) {
      return data;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.privilege-group {
  padding: 16px 16px 0 16px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  .controler {
    display: flex;
    margin: 0 0 10px 0;
    justify-content: space-between;
  }
  .lc {
    margin-left: 15px;
  }
  .page-wrap {
    padding-top: 10px;
  }
  .action-links {
    display: flex;
    align-items: center;
    white-space: nowrap;
    gap: 12px;
  }
}
</style>
<style lang="less">
.privilege-group {
  .el-input__icon {
    line-height: 30px !important;
  }
  .el-input-group {
    width: 240px;
  }
}
</style>
